import {
  getAllEmployees,
  getJobRequisitionView,
  getManagerEmployeesListing,
  updateEmployee,
} from "Api/apiService";
import { ERROR_MESSAGES, MANAGER_TYPE } from "constants/employee.constants";
export const keyPrefix = "EMPLOYEE_LIST_REDUCER_";

export const EMPLOYEE_LIST_ACTIONS = {
  SET_EMPLOYEE: keyPrefix + "SET_EMPLOYEE",
  FETCH_EMPLOYEES_LOADER: keyPrefix + "FETCH_EMPLOYEES_LOADER",
  UPDATE_EMPLOYEE_LOADER: keyPrefix + "UPDATE_EMPLOYEE_LOADER",
  TOAST_MESSAGE: keyPrefix + "TOAST_MESSAGE",
  CLEAR_EMPLOYEES: keyPrefix + "CLEAR_EMPLOYEES",
  SET_MANAGER_EMPLOYEES_LIST: keyPrefix + "SET_MANAGER_EMPLOYEES_LIST",
  CLEAR_EMPLOYEES_DRAWER_DATA: keyPrefix + "CLEAR_EMPLOYEES_DRAWER_DATA",
  SET_HRBP_EMP_ID_LIST: keyPrefix + "SET_HRBP_EMP_ID_LIST",
  SET_REQUISITION_VIEW: keyPrefix + "SET_REQUISITION_VIEW",
  SET_COMPLETE_EMPLOYEES: keyPrefix + "SET_COMPLETE_EMPLOYEES",
};

export const clearEmployees = () => ({
  type: EMPLOYEE_LIST_ACTIONS.CLEAR_EMPLOYEES,
});

export const clearEmployeesDrawerData = () => ({
  type: EMPLOYEE_LIST_ACTIONS.CLEAR_EMPLOYEES_DRAWER_DATA,
});

export const setEmployee = (employees) => ({
  type: EMPLOYEE_LIST_ACTIONS.SET_EMPLOYEE,
  payload: employees,
});

export const fetchEmployeeLoader = (isLoading) => ({
  type: EMPLOYEE_LIST_ACTIONS.FETCH_EMPLOYEES_LOADER,
  payload: isLoading,
});

export const updateEmployeeLoader = (isLoading) => ({
  type: EMPLOYEE_LIST_ACTIONS.UPDATE_EMPLOYEE_LOADER,
  payload: isLoading,
});

export const toastMessage = ({ show, message }) => ({
  type: EMPLOYEE_LIST_ACTIONS.TOAST_MESSAGE,
  payload: { show, message },
});

export const setManagerEmployeesList = (managerEmployees) => ({
  type: EMPLOYEE_LIST_ACTIONS.SET_MANAGER_EMPLOYEES_LIST,
  payload: managerEmployees,
});

export const setHRBPEmpIDList = (HRBPEmpIDs) => ({
  type: EMPLOYEE_LIST_ACTIONS.SET_HRBP_EMP_ID_LIST,
  payload: HRBPEmpIDs,
});

export const setRequisitionView = (requisitionView) => ({
  type: EMPLOYEE_LIST_ACTIONS.SET_REQUISITION_VIEW,
  payload: requisitionView,
});

export const setCompleteEmployees = (complete) => ({
  type: EMPLOYEE_LIST_ACTIONS.SET_COMPLETE_EMPLOYEES,
  payload: complete,
});

export const fetchAllEmployees = ({
  pageNo,
  totalRecordsPerPage,
  complete,
}) => {
  return async (dispatch) => {
    try {
      dispatch(fetchEmployeeLoader(true));

      dispatch(setCompleteEmployees(complete));
      const employeesResponse = await getAllEmployees({
        pageNo,
        totalRecordsPerPage,
        complete,
      });
      
      if (employeesResponse) {
        dispatch(setEmployee(employeesResponse));
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || ERROR_MESSAGES.SOMETHING_WENT_WRONG;
      dispatch(toastMessage({ show: true, message: errorMessage }));
    } finally {
      dispatch(fetchEmployeeLoader(false));
    }
  };
};

export const updateEmployeesApi = ({updatedEmployeePayload, employeeId}) => {
  return async (dispatch) => {
    try {
      dispatch(updateEmployeeLoader(true));
      const updateEmployeeResponse = await updateEmployee({updatedEmployeePayload, employeeId});
      if (!updateEmployeeResponse) {
        console.log("updateEmployee: No response return");
        return;
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || ERROR_MESSAGES.SOMETHING_WENT_WRONG;
      dispatch(toastMessage({ show: true, message: errorMessage }));
    } finally {
      dispatch(updateEmployeeLoader(false));
    }
  };
};

export const fetchManagerEmployeesListingAPI = () => {
  return async (dispatch) => {
    try {
      const managerEmployeesResponse = await getManagerEmployeesListing({
        managerType: MANAGER_TYPE.REPORTING_MANAGER,
      });
      if (managerEmployeesResponse) {
        dispatch(setManagerEmployeesList(managerEmployeesResponse));
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || ERROR_MESSAGES.SOMETHING_WENT_WRONG;
      dispatch(toastMessage({ show: true, message: errorMessage }));
    }
  };
};

export const fetchHRBPEmpIDListingAPI = () => {
  return async (dispatch) => {
    try {
      const HRBPEmpIDResponse = await getManagerEmployeesListing({
        managerType: MANAGER_TYPE.HRBP,
      });
      if (HRBPEmpIDResponse) {
        dispatch(setHRBPEmpIDList(HRBPEmpIDResponse));
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || ERROR_MESSAGES.SOMETHING_WENT_WRONG;
      dispatch(toastMessage({ show: true, message: errorMessage }));
    }
  };
};

export const fetchRequisitionViewAPI = (email) => {
  return async (dispatch) => {
    try {
      const jobRequisitionResponse = await getJobRequisitionView(email);

      if (jobRequisitionResponse) {
        dispatch(setRequisitionView(jobRequisitionResponse));
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || ERROR_MESSAGES.SOMETHING_WENT_WRONG;
      dispatch(toastMessage({ show: true, message: errorMessage }));
    }
  };
};
